import React, { useState } from 'react';
import { ChevronDownIcon, MusicalNoteIcon } from '@heroicons/react/24/outline';

const SongSelector = ({ songs, onSongSelect, excludeSongIds = [], className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  
  console.log('SongSelector received songs:', songs);
  console.log('Excluding song IDs:', excludeSongIds);

  const availableSongs = songs.filter(song => 
    !excludeSongIds.includes(song.id) && 
    (song.status === 'GOOD' || song.status === 'IN_PROGRESS')
  );
  
  const filteredSongs = availableSongs.filter(song =>
    song.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    song.artist.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSongSelect = (song) => {
    onSongSelect(song.id);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        disabled={availableSongs.length === 0}
        className={`px-3 py-1 rounded text-sm flex items-center space-x-1 ${
          availableSongs.length === 0
            ? 'bg-gray-400 text-white cursor-not-allowed'
            : 'bg-blue-600 text-white hover:bg-blue-700'
        }`}
      >
        <MusicalNoteIcon className="w-4 h-4" />
        <span>Add Song</span>
        <ChevronDownIcon className="w-3 h-3" />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-20 min-w-80">
          <div className="p-2">
            <input
              type="text"
              placeholder="Search songs..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-blue-500 focus:border-blue-500"
              autoFocus
            />
          </div>
          <div className="max-h-60 overflow-auto">
            {songs.length === 0 ? (
              <div className="px-3 py-2 text-sm text-gray-500">
                <div className="font-medium">No songs available</div>
                <div className="text-xs mt-1">Add songs first in the Songs page to use them in setlists</div>
              </div>
            ) : availableSongs.length === 0 ? (
              <div className="px-3 py-2 text-sm text-gray-500">
                <div className="font-medium">No eligible songs available</div>
                <div className="text-xs mt-1">Only GOOD or IN_PROGRESS songs can be added to sets</div>
              </div>
            ) : filteredSongs.length === 0 ? (
              <div className="px-3 py-2 text-sm text-gray-500">
                No songs found matching "{searchTerm}"
              </div>
            ) : (
              filteredSongs.map((song) => (
                <button
                  key={song.id}
                  type="button"
                  onClick={() => handleSongSelect(song)}
                  className="w-full text-left px-3 py-2 hover:bg-gray-50 border-b border-gray-100 last:border-0"
                >
                  <div className="text-sm font-medium text-gray-900">{song.title}</div>
                  <div className="text-xs text-gray-500">{song.artist}</div>
                </button>
              ))
            )}
          </div>
        </div>
      )}

      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 z-10"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default SongSelector;